import api from './api';

export const usuarioService = {
  listar: () => api.get('/usuarios'),
  obter: (id: string) => api.get(`/usuarios/${id}`),
  criar: (data: string) => api.post('/usuarios/create', data),
  atualizar: (id: string, data: string) => api.put(`/usuarios/${id}`, data),
  excluir: (id: string) => api.delete(`/usuarios/${id}`),
  atualizarPerfil: (data: string) => api.put('/usuarios/profile', data),
  alterarSenha: (senhaAtual: string, novaSenha: string) =>
    api.put('/usuarios/change-password', { senhaAtual, novaSenha }),
};
